import { gql } from '__generated__';

export default gql(`
  query GetProducts($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        active
        products {
          id
          title
          type
          stand_alone
          promotions {
            id
            amount
            start_date
            end_date
            active
          }
          sold_count
          capacity
          active
          is_sold_out
          deletable
        }
      }
    }
  }
`);
